exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qrCode-dialog {\n  width: 2.291667rem !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n.qrCode-dialog .el-dialog__header {\n  background: transparent;\n}\n.qrCode-dialog .el-dialog__body {\n  background: transparent;\n}", ""]);

// exports
